import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

import LogbookSignatureModal from '../../LogbookAppIntegration/LogbookSignatureModal';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookAirworthinessReleaseTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          logbook_app: this.props.logbook_app,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          approvals: [],
          approval: [],
          airworthiness_releases: '',
          justification: null,
          id: '',
          last_maintenance_intervention_type_id: '',
          next_maintenance_intervention_type_id: '',
          last_maintenance_intervention_option: '',
          next_maintenance_intervention_option: '',
          flight_hours_next_maintenance_intervention: '',
          rts: false,
          pre_flight: false,
          no_task: false,
          no_item: false,
          released_for: '',
          release_flight_hours: '',
          next_type: 'select',
          last_type: 'select',
          rawInputValue: '',
          inputValue: '',
          maintenance_intervention_types_list: '',
          modal_justification: false,
          email: '',
          password: '',
          showLogbookSignatureModal: false,
          editMessage: '',
          logbookIntegrationMessage: '',
          airworthiness_status: 'non_airworthy',
        };
        this.edit = this.edit.bind(this);
        this.reopen = this.reopen.bind(this);
        this.logbookIntegration = this.logbookIntegration.bind(this);
        this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
      }

      handleChangeDecimal = (name, event) => {
        let rawInputValue = this.state.rawInputValue;
        console.log('first rawInputValue:')
        console.log(rawInputValue);
      
        let inputValue = event.target.value;
      
        // Se o input estiver vazio, limpa rawInputValue
        if (inputValue === '') {
          rawInputValue = '';
        } else if (/^\d+$/.test(inputValue)) {
          // Se for um número inteiro, atualiza rawInputValue
          rawInputValue = inputValue;
        } else {
          let newChar = inputValue.slice(-1);
      
          // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
          if (!/^[0-9.,]$/.test(newChar)) {
            // Caractere inválido, não faz nada
            return;
          }
      
          // Substitui vírgula por ponto
          if (newChar === ',') {
            newChar = '.';
          }
      
          // Verifica se já existe um ponto decimal
          let hasDecimal = rawInputValue.includes('.');
      
          // Impede que "0" seja o primeiro dígito
          if (rawInputValue === '' && newChar === '0') {
            return;
          }
      
          // Determina se está adicionando ou removendo um caractere
          if (event.nativeEvent.inputType === 'deleteContentBackward') {
            // Removendo um caractere
            rawInputValue = rawInputValue.slice(0, -1);
          } else if (hasDecimal && newChar !== '.') {
            // Substitui o dígito após o ponto decimal
            let parts = rawInputValue.split('.');
            parts[1] = newChar;
            rawInputValue = parts.join('.');
          } else {
            // Adicionando um caractere
            rawInputValue += newChar;
          }
        }
      
        // Formata o valor para exibição com base em rawInputValue
        let formattedValue = this.formatInputValue(rawInputValue);
      
        // Atualiza o estado
        this.setState({
          [name]: formattedValue,
          rawInputValue: rawInputValue
        });
      };
                                    
      formatInputValue = (rawValue) => {
        if (!rawValue) {
          return '';
        }

        let [inteiro, decimal] = rawValue.split('.');

        // Ajusta a parte decimal para sempre ter um dígito
        decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

        return `${inteiro}.${decimal}`;
      };

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleAirworthinessStatusChange = (event) => {
        const value = event && event.value ? event.value : null;
        if (!value) {
          this.setState({ airworthiness_status: 'non_airworthy' });
          return;
        }
        // When Airworthy, force 'any_flight' and disable the flight type select
        if (value === 'airworthy') {
          this.setState({ airworthiness_status: 'airworthy', released_for: 'any_flight' });
        } else {
          // Non-Airworthy: if current released_for is 'any_flight', switch to a valid non-airworthy default
          let released_for = this.state.released_for;
          if (released_for === 'any_flight') {
            // Prefer 'power_check' if available, else 'maintenance_flight'
            const list = (this.state.flight_type_list || []);
            const hasPower = list.find((o) => o.value === 'power_check');
            const hasMaint = list.find((o) => o.value === 'maintenance_flight');
            released_for = hasPower ? 'power_check' : (hasMaint ? 'maintenance_flight' : null);
          }
          this.setState({ airworthiness_status: 'non_airworthy', released_for });
        }
      }

      handleCheckboxChange(name, event) {
        // valor selecionado. Valor são true e false
        var value = event.target.checked;
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = value;
        }
        this.setState(change);
      }
    
            
      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            logbook_app: newProps.logbook_app,
            loaded: 1,
          });
        }

        if(typeof newProps.airworthiness_releases !== 'undefined' && newProps.airworthiness_releases !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            airworthiness_releases: newProps.airworthiness_releases,
            flight_type_list: newProps.flight_type_list,
            id: newProps.airworthiness_releases.id,
            last_maintenance_intervention_type_id: newProps.airworthiness_releases.last_maintenance_intervention_type_id,
            next_maintenance_intervention_type_id: newProps.airworthiness_releases.next_maintenance_intervention_type_id,
            flight_hours_next_maintenance_intervention: newProps.airworthiness_releases.flight_hours_next_maintenance_intervention_str,
            rts: newProps.airworthiness_releases.rts,
            pre_flight: newProps.airworthiness_releases.pre_flight,
            no_task: newProps.airworthiness_releases.no_task,
            no_item: newProps.airworthiness_releases.no_item,
            released_for: newProps.airworthiness_releases.released_for,
            release_flight_hours: newProps.airworthiness_releases.release_flight_hours,
            rawInputValue: newProps.airworthiness_releases.flight_hours_next_maintenance_intervention_decimal,
          }, () => {
            // Initialize airworthiness status based on 'released_for'
            const anyOption = (this.state.flight_type_list || []).find((o) => o.value === 'any_flight');
            const status = this.state.released_for === 'any_flight' && anyOption ? 'airworthy' : 'non_airworthy';
            this.setState({ airworthiness_status: status });
          });
        }

        if(typeof newProps.maintenance_intervention_types_list !== 'undefined' && newProps.maintenance_intervention_types_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            maintenance_intervention_types_list: newProps.maintenance_intervention_types_list,
          });
        }

        this.setState({
          approvals: [],
          approval: [],
        });
        if(typeof newProps.approvals[3] !== 'undefined' && newProps.approvals[3] !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[3],
            approval: newProps.approvals[3][0],
          });
        }
      }
    
      // Fetch salvando a edição
      edit(event) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          id: this.state.id,
          last_maintenance_intervention_type_id: this.state.last_maintenance_intervention_type_id,
          next_maintenance_intervention_type_id: this.state.next_maintenance_intervention_type_id,
          last_maintenance_intervention_option: this.state.last_maintenance_intervention_option,
          next_maintenance_intervention_option: this.state.next_maintenance_intervention_option,
          flight_hours_next_maintenance_intervention: this.state.flight_hours_next_maintenance_intervention,
          released_for: this.state.released_for,
          // release_days and checkboxes removed from UI per new requirements
          // release_flight_hours kept as-is if used elsewhere
          last_type: this.state.last_type,
          next_type: this.state.next_type,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/aeronavegabilidade', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
                self.setState({ editMessage: responseJson.message }, () => {
                  // Se tiver integração com o Logbook App, chama a função de integração
                  if (self.props.logbook_app == 1) {
                    self.logbookIntegrationSubmit();
                  } else {
                    self.props.updateData(responseJson);
                  }
              });
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      reopen(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var datasave = {
          id: this.state.id,
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          justification: this.state.justification,
        };
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/aeronavegabilidade/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({ modal_justification: false, justification: null });
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      changeLastInput(type) {
        this.setState({
          last_type: type,
        });
      }
      
      changeNextInput(type) {
        this.setState({
          next_type: type,
        });
      }

      // Integração com o Logbook App
      logbookIntegration(event) {
        // Se tiver integração com o Logbook App
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({ showLogbookSignatureModal: true });
        } else {
          // Se não tiver integração, chama a função de edição diretamente
          this.edit();
        }
      }
      
      handleLogbookSignatureSubmit(credentials) {
        // Recebe { email, password } do modal e atualiza o state
        this.setState({
          email: credentials.email,
          password: credentials.password,
          showLogbookSignatureModal: false
        }, () => {
          // Após informar as credenciais, chama a função de edição
          this.edit();
        });
      }
      
      // Chamada para integração após ter email e password preenchidos
      logbookIntegrationSubmit() {
        const datasave = {
          id: this.state.id,
          email: this.state.email,
          password: this.state.password
        };
        const header = this.refs.request_api.header('application/json');
        const self = this;
        Promise.resolve(header).then(function (value) {
          fetch(config.get('api') + '/integrar/logbook/aeronavegabilidade', {
            method: 'PUT',
            mode: 'cors',
            headers: value,
            body: JSON.stringify(datasave)
          })
            .then((response) => response.json())
            .catch((error) => {
              console.error(error);
            })
            .then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({ logbookIntegrationMessage: responseJson.message }, () => {
                self.props.updateData(self.groupedMessages(responseJson.status));
              });
            })
            .catch((error) => {
              console.error(error);
            });
        });
      }

      groupedMessages(status) {
        const combinedMessage = (
          <div>
            <strong>SIGVOOS:</strong><br />
            {this.state.editMessage || ''}<br />
            <hr />
            <strong>Logbook App:</strong><br />
            {this.state.logbookIntegrationMessage || ''}<br />
          </div>
        );
        
        return {
          status: status,
          message: combinedMessage
        };
      }
    
      render() {
        var self = this;
        const flightTypeList = this.state.flight_type_list || [];
        const airworthinessOptions = [
          { value: 'airworthy', label: 'Airworthy' },
          { value: 'non_airworthy', label: 'Non-Airworthy' },
        ].filter((opt) => {
          if (opt.value === 'airworthy') {
            // Only allow Airworthy when 'Any Flight' option is available
            return !!flightTypeList.find((o) => o.value === 'any_flight');
          }
          return true;
        });
        const nonAirworthyFlightTypes = flightTypeList.filter((o) => o.value === 'power_check' || o.value === 'maintenance_flight');
        const isAirworthy = this.state.airworthiness_status === 'airworthy';
        return (
        <div>
          <RequestApi ref={'request_api'} />
          <div className="row">
            <div className="col-md-1 text-center">
              {
                (self.state.approval.status === 1) ?
                  <button onClick={() => self.setState({ modal_justification: true })} className="btn btn-primary"><i className="fa fa-fw fa-refresh"></i></button>
                :
                  <button onClick={() => {self.logbookIntegration()}} className="btn btn-success"><i className="fa fa-check"></i></button>
              }
            </div>
            <div className='col-md-7'>
              <h3 className="page-title pull-left">Airworthiness Release</h3>
              <div className="clearfix"></div>
            </div>
            <div className='col-md-4'>
              <div className="table-responsive">
                <table className="table table-bordered table-hover table-striped">
                  <caption>Approval</caption>
                  <thead>
                    <tr className="text-center">
                      <th>User</th>
                      <th>Status</th>
                      <th>Approval Date</th>
                    </tr>
                  </thead>
                  <tbody id="airworthiness_release_approvals">
                  {self.state.approvals.map(function(k) {
                    var approval = k;
                    return(
                      <tr className="text-center" key={approval.id}>
                        {
                          (typeof approval.user_id !== 'undefined' && approval.user_id !== null) ?
                          <td>{approval.user_name}</td>
                          :
                          <td></td>
                        }
                        <td>{approval.status_str}</td>
                        <td>{approval.approval_date_str}</td>
                      </tr>
                    );
                  })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <form onSubmit={this.edit}>
            <div className="row" style={{padding:'0px 0px 0px 50px'}}>
              <div className='col-md-8'>
                <div className='row'>
                  <div className='col-md-12'>
                    <h4>Unless new maintenance/crew reports are recorded below, I hereby certify that the release above inspection was performed and this aircraft is approved to release to service for:</h4>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Airworthiness</label>
                      <br/>
                      <Select
                        className="form-group"
                        name="airworthiness_status"
                        value={this.state.airworthiness_status}
                        searchable={false}
                        placeholder={'Select airworthiness status'}
                        onChange={this.handleAirworthinessStatusChange}
                        options={airworthinessOptions}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Authorized - Flight Type</label>
                      <br/>
                      <Select
                        className="form-group"
                        name="released_for"
                        value={this.state.released_for}
                        searchable={true}
                        placeholder={'Selecionar tipo de voo liberado'}
                        onChange={this.handleSelectChange.bind(this, 'released_for')}
                        options={isAirworthy ? flightTypeList.filter((o) => o.value === 'any_flight') : nonAirworthyFlightTypes}
                        disabled={isAirworthy}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="row">
                  {this.state.last_type === 'input' ?  
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>New maintenance option:<button type="button" onClick={() => {self.changeLastInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                        <input type="text" name="last_maintenance_intervention_option" className="form-control" placeholder="" value={this.state.last_maintenance_intervention_option} onChange={this.handleChange.bind(this, 'last_maintenance_intervention_option')} required />
                      </div>
                    </div>
                  : 
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Last Maintenance Intervention Type:<button type="button" onClick={() => {self.changeLastInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                        <br/>
                        <Select
                          className="form-group"
                          name="last_maintenance_intervention_type_id"
                          value={this.state.last_maintenance_intervention_type_id}
                          searchable={true}
                          placeholder={'Selecionar tipo da última intervenção de manutenção'}
                          onChange={this.handleSelectChange.bind(this, 'last_maintenance_intervention_type_id')}
                          options={this.state.maintenance_intervention_types_list}
                          required
                        />
                      </div>
                    </div>
                  }
                  {this.state.next_type === 'input' ?  
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>New maintenance option:<button type="button" onClick={() => {self.changeNextInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                        <input type="text" name="next_maintenance_intervention_option" className="form-control" placeholder="" value={this.state.next_maintenance_intervention_option} onChange={this.handleChange.bind(this, 'next_maintenance_intervention_option')} required />
                      </div>
                    </div>
                  : 
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Next Maintenance Intervention Type:<button type="button" onClick={() => {self.changeNextInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                        <br/>
                        <Select
                          className="form-group"
                          name="next_maintenance_intervention_type_id"
                          value={this.state.next_maintenance_intervention_type_id}
                          searchable={true}
                          placeholder={'Selecionar tipo da próxima intervenção de manutenção'}
                          onChange={this.handleSelectChange.bind(this, 'next_maintenance_intervention_type_id')}
                          options={this.state.maintenance_intervention_types_list}
                          required
                        />
                      </div>
                    </div>
                  }
                  <div className="col-md-12">
                    <div className="form-group">
                      <div className='col-md-6'>
                        <label>
                          Hours Until Next Maintenance Intervention:
                        </label>
                      </div>
                      <div className='col-md-6'>
                        <input value={this.state.flight_hours_next_maintenance_intervention} name="flight_hours_next_maintenance_intervention" className="form-control" onChange={this.handleChangeDecimal.bind(this, 'flight_hours_next_maintenance_intervention')} placeholder="hh.m" required/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          
          <hr/>
          {/* Modal de justificativa para reabertura */}
          <Modal show={this.state.modal_justification} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
            <Modal.Header>
              <h4 className="pull-left"><strong>Please tell us why you need to reopen this airworthiness release</strong></h4>
              <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}><i className="fa fa-fw fa-close"></i></button>
              <div className="clearfix"></div>
            </Modal.Header>
            <Modal.Body>
              <p className="alert alert-danger">Attention: This reopening should only be used in case of filling errors. For a new airworthiness release after changing the aircraft's conditions, please open a new logbook.</p>
              <form onSubmit={this.reopen}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Justification:</label>
                      <textarea style={{ height: 200 }} type="text" name="justification" required className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-certificate"></i> Submit justification</button>
                    </div>
                  </div>
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal_justification: false, justification: null})}>
              <i className="fa fa-fw fa-close"></i></button>
            </Modal.Footer>
          </Modal>
          {/* Modal de assinatura do LogbookApp */}
          <LogbookSignatureModal
            show={this.state.showLogbookSignatureModal}
            onHide={() => this.setState({ showLogbookSignatureModal: false })}
            onSubmit={this.handleLogbookSignatureSubmit}
            title="Você tem certeza de que deseja integrar e editar os dados de aeronavegabilidade no Logbook App?"
            subtitle="Ao confirmar a assinatura digital anterior será revogada e a sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema."
          />
        </div>
    );
  }
}

export default AircraftLogbookAirworthinessReleaseTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookAirworthinessReleaseTab.js